import { createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import { postGetPrivateProjectBankFileUploadSignedUrl } from 'scenes/ProjectBank/services/private-project-bank/getPrivateProjectBankFileUploadSignedUrl.service';
import { postPrivateProjectBankItem } from 'scenes/ProjectBank/services/private-project-bank/postPrivateProjectBankItem.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectSelectedPrivateProjectBankFolderId } from '../../selectors/project-bank.selectors';

export const uploadPrivateProjectBankFile = createAsyncThunk(
  'project-bank/uploadPrivateProjectBankFile',
  async ({ fileType, file }, { getState }) => {
    const projectId = selectSelectedProjectId(getState());

    const parentFolderId = selectSelectedPrivateProjectBankFolderId(getState());

    const uploadSignedUrlData =
      await postGetPrivateProjectBankFileUploadSignedUrl(projectId, fileType);

    if (uploadSignedUrlData) {
      const options = {
        headers: {
          'Content-Type': fileType,
        },
      };

      const { uploadUrl, fileId } = uploadSignedUrlData;

      await Axios.put(uploadUrl, file, options);

      const privateFileAttributes = {
        name: file.name,
        mimeType: fileType,
        size: file.size,
        fileId,
        parentFolderId: parentFolderId || undefined,
      };

      const response = await postPrivateProjectBankItem(
        projectId,
        privateFileAttributes
      );

      return response;
    }
  }
);
